import React from 'react';
import cn from 'classnames';
import { string } from 'prop-types';

import './styles.scss';

const SVG_PREFIX = 'data:image/svg+xml;utf8,';

// Drop-in replacement for @ionic/react's IonIcon. Renders the ionicons
// data-url svg inline (same <ion-icon> tag, so existing styles keep working)
// without shipping the Ionic/Stencil runtime in the bundle.
const IonIcon = ({ icon = '', size, className, ...props }) => (
  <ion-icon
    role="img"
    // Decorative by default: without an accessible name, screen readers
    // would announce a nameless "image" on every icon
    aria-hidden={props['aria-label'] ? undefined : 'true'}
    {...props}
    class={cn(className, { [`icon-${size}`]: size }) || undefined}
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML={{
      __html: icon.startsWith(SVG_PREFIX) ? icon.slice(SVG_PREFIX.length) : ''
    }}
  />
);

IonIcon.propTypes = {
  'aria-label': string,
  className: string,
  icon: string,
  size: string
};

export default IonIcon;
